export { default } from './PricingTable.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/PricingTable/index.js